export const TABLE_PADDING_STORAGE_KEY = "turbonotes2-table-padding";
export const TABLE_ALIGN_STORAGE_KEY = "turbonotes2-table-align";
export const TABLE_POSITION_STORAGE_KEY = "turbonotes2-table-position";
export const TABLE_WIDTH_STORAGE_KEY = "turbonotes2-table-width";

export const TABLE_PADDINGS = ["tight", "normal", "roomy"] as const;
export const TABLE_ALIGNS = ["left", "center", "right"] as const;
export const TABLE_POSITIONS = ["left", "center", "right"] as const;
export const TABLE_WIDTHS = ["stretch", "compact"] as const;

export type TablePadding = (typeof TABLE_PADDINGS)[number];
export type TableAlign = (typeof TABLE_ALIGNS)[number];
export type TablePosition = (typeof TABLE_POSITIONS)[number];
export type TableWidth = (typeof TABLE_WIDTHS)[number];

export interface TableSettings {
  padding: TablePadding;
  align: TableAlign;
  position: TablePosition;
  width: TableWidth;
}

export const DEFAULT_TABLE_SETTINGS: Readonly<TableSettings> = {
  padding: "normal",
  align: "left",
  position: "left",
  width: "stretch",
};

export const isTablePadding = (value: unknown): value is TablePadding =>
  TABLE_PADDINGS.includes(value as TablePadding);
export const isTableAlign = (value: unknown): value is TableAlign =>
  TABLE_ALIGNS.includes(value as TableAlign);
export const isTablePosition = (value: unknown): value is TablePosition =>
  TABLE_POSITIONS.includes(value as TablePosition);
export const isTableWidth = (value: unknown): value is TableWidth =>
  TABLE_WIDTHS.includes(value as TableWidth);

export function loadTableSettings(storage: Pick<Storage, "getItem">): TableSettings {
  const padding = storage.getItem(TABLE_PADDING_STORAGE_KEY);
  const align = storage.getItem(TABLE_ALIGN_STORAGE_KEY);
  const position = storage.getItem(TABLE_POSITION_STORAGE_KEY);
  const width = storage.getItem(TABLE_WIDTH_STORAGE_KEY);
  return {
    padding: isTablePadding(padding) ? padding : DEFAULT_TABLE_SETTINGS.padding,
    align: isTableAlign(align) ? align : DEFAULT_TABLE_SETTINGS.align,
    position: isTablePosition(position) ? position : DEFAULT_TABLE_SETTINGS.position,
    width: isTableWidth(width) ? width : DEFAULT_TABLE_SETTINGS.width,
  };
}
